import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/styles';
import { Typography, Link } from '@material-ui/core';

const propTypes = {
    children: PropTypes.node,
    linkText: PropTypes.string,
    onLinkClick: PropTypes.func,
    href: PropTypes.string
};

const defaultProps = {
    children: null,
    linkText: null,
    onLinkClick: undefined,
    href: undefined
};

const useStyles = makeStyles((theme) => styles(theme));

function AuthBodyConfirmation ({ linkText, href, onLinkClick, children, LinkProps, ...otherProps }) {
    const classes = useStyles();
    return (
        <Typography
            classes={{ root: classNames(classes.root) }}
            {...otherProps}
        >
            { children } 
            { " " }
            <Link 
                classes={{ root: classes.link }}
                href={href}
                onClick={onLinkClick}
                underline="always"
                {...LinkProps}
            >
                {linkText}
            </Link>
        </Typography>
    );
}

const styles = (theme) => ({
    root: {
        fontSize: '14px',
        color: theme.palette.grey.variant3
    },
    link: {
        color: theme.palette.primary.main,
        fontWeight: 600,
    }
});

AuthBodyConfirmation.propTypes = propTypes;
AuthBodyConfirmation.defaultProps = defaultProps;

export default AuthBodyConfirmation;